export const getWorkCenterLocationByCollaboratorInitialState = {
	workCenters: null,
	error: null,
	errorShow: false,
	loading: false,
};
